import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getConversationMessageHistory } from "store/services/clientMessagingService";

export const useConversation = (userId) => {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const [showLoadMore, setShowLoadMore] = useState(false);

  const messageListRef = useRef(null);
  const messagesEndRef = useRef(null);

  const conversation = useSelector((state) => state.ClientMessaging.conversation);

  const fetchMessageHistory = async (lastMessageId) => {
    if (!conversation?.conversation_id) return;
    try {
      setLoading(true);
      await dispatch(getConversationMessageHistory(conversation.conversation_id, lastMessageId));
    } catch (error) {
      console.error("Error fetching chat history:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLoadPrevious = async () => {
    if (!conversation?.messages?.length || !messageListRef.current) return;

    const prevScrollHeight = messageListRef.current.scrollHeight;
    const oldestMessage = conversation.messages[0];

    await fetchMessageHistory(oldestMessage.id);

    requestAnimationFrame(() => {
      const newScrollHeight = messageListRef.current.scrollHeight;
      messageListRef.current.scrollTop = newScrollHeight - prevScrollHeight;
    });

    setShowLoadMore(false);
  };

  const handleScroll = () => {
    if (messageListRef.current?.scrollTop === 0) {
      setShowLoadMore(true);
    } else {
      setShowLoadMore(false);
    }
  };

  // useEffect(() => {
  //   if (conversation?.messages?.length && !hasScrolled) {
  //     requestAnimationFrame(() => {
  //       messagesEndRef.current?.scrollIntoView();
  //       setHasScrolled(true);
  //     });
  //   }
  // }, [conversation?.messages?.length, hasScrolled, conversationId]);

  useEffect(() => {
    if (!conversation?.messages?.length) return;
  
    const lastMessage = conversation.messages[conversation.messages.length - 1];
    const isFromUser = Number(lastMessage?.sender_id) === Number(userId);
  
    if (!hasScrolled || isFromUser) {
      requestAnimationFrame(() => {
        messagesEndRef.current?.scrollIntoView();
        setHasScrolled(true);
      });
    }
  }, [conversation?.messages?.length, conversation]);

  useEffect(() => {
    if (!conversation?.conversation_id) return;
    fetchMessageHistory();
  }, [conversation?.conversation_id]);

  return {
    conversation,
    isLoading,
    messageListRef,
    messagesEndRef,
    showLoadMore,
    handleScroll,
    handleLoadPrevious,
  };
};
